// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"e215a653","348":"2a67b212","412":"5e16f16c","415":"47ae7aea","429":"8cc74edf","479":"b9ebdeb8","665":"c8c8ce85","758":"fbf08aa7","784":"c31a1a09","919":"a305da16","937":"eaa788f3"}[chunkId] + ".chunk.js";
};